module.exports = __webpack_public_path__ + "images/gplines/map.png";